var subnavToggles = document.querySelectorAll('.subnav__toggle');
for (var i = 0, len = subnavToggles.length; i < len; i++) {
  var subnavToggle = subnavToggles[i];
  subnavToggle.addEventListener('click', function(e) {
    this.parentNode.classList.toggle('subnav__item--active');
    e.preventDefault();
  });
}
